import { render, staticRenderFns } from "./CopyrightResult.vue?vue&type=template&id=2eda5026"
import script from "./CopyrightResult.vue?vue&type=script&lang=js"
export * from "./CopyrightResult.vue?vue&type=script&lang=js"
import style0 from "./CopyrightResult.vue?vue&type=style&index=0&id=2eda5026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports